﻿import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalReports`,
  scopes: ExtHubRequest,
});
const powerBiApi = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/PowerBi`,
  scopes: ExtHubRequest,
});

api.createEntities([
  { name: 'GetReportCategories' },
  { name: 'GetReportsByCategoryAndProducer' },
  { name: 'GenerateReportLink' },
  { name: 'OnePagePolicyReport' },
]);

powerBiApi.createEntities([{ name: 'GetEmbedConfig' }]);
powerBiApi.createEntities([{ name: 'DashboardEmbedConfig' }]);

const GetReportCategories = () => api.endpoints.GetReportCategories.post();
const GetReportsByCategoryAndProducer = (body) =>
  api.endpoints.GetReportsByCategoryAndProducer.post(body);
const GenerateReportLink = (body) => api.endpoints.GenerateReportLink.post(body);
const OnePagePolicyReport = (body) => api.endpoints.OnePagePolicyReport.post(body);
const GetEmbedConfig = (body) => powerBiApi.endpoints.GetEmbedConfig.post(body);
const GetDashboardEmbedConfig = (body) => powerBiApi.endpoints.DashboardEmbedConfig.post(body);

export {
  GetReportCategories,
  GetReportsByCategoryAndProducer,
  GenerateReportLink,
  OnePagePolicyReport,
  GetEmbedConfig,
  GetDashboardEmbedConfig,
};
